const translation = {
  // Navigation
  nav_home: '首页',
  nav_gallery: '画廊',
  nav_features: '特色',
  nav_location: '位置',
  nav_contact: '联系',

  // Hero Section
  hero_title: '意大利北部中心的当代奢华',
  hero_subtitle: '总室内面积：505平方米 | 商业面积：667.31平方米 | 室外面积：1,190平方米 | A3能源等级 | 智能家居技术 | 加热盐水泳池',
  hero_cta: '预约参观',
  hero_learn_more: '了解更多',
  hero_property_info: '总室内面积：505平方米 | 商业面积：667.31平方米 | 室外面积：1,190平方米 | A3能源等级 | 智能家居技术 | 加热盐水泳池',

  // Key Info
  key_info_title: '房产概览',
  key_info_size: '居住面积',
  key_info_size_value: '350平方米',
  key_info_bedrooms: '卧室',
  key_info_bedrooms_value: '4间',
  key_info_bathrooms: '浴室',
  key_info_bathrooms_value: '3间',
  key_info_energy: '能效等级',
  key_info_energy_value: 'A3',
  key_info_year: '建造年份',
  key_info_year_value: '2020年',
  key_info_parking: '停车位',
  key_info_parking_value: '双车库',

  // Description
  desc_title: '建筑卓越与现代生活的完美结合',
  desc_p1: '别墅外部设有带LED照明的加热盐水泳池。该系统集成了色彩疗法选项,可自主运行以平衡盐分和pH值。周围的花园由自动灌溉系统管理,该系统由10,000升地下雨水收集罐供电。',
  desc_p2: '别墅的能源等级为A3。能源通过两个光伏系统(总计20千瓦)提供,具有40千瓦的储能容量,一个根据光伏系统产生的能源运行的冷凝锅炉,10个太阳能热板,以及分为3个区域的分区地暖。',
  desc_p3: '整个物业使用的材料和技术都是高质量的,并根据功能性和耐用性进行选择:关键室内区域(例如厨房、浴室)采用法国石材,卧室采用船用级柚木,定制木工,集成Bang & Olufsen音视频系统,西门子、博世、利勃海尔、KitchenAid和美诺电器,大金多区气候控制,以及集中式泳池和灌溉管理。',
  desc_p4: '别墅位于阿尔奇萨泰,步行即可到达(约5分钟)火车站,可直达瓦雷泽、米兰、马尔彭萨机场、科莫和瑞士。开车前往瓦雷泽约15分钟;卢加诺(瑞士)约30分钟;米兰或马尔彭萨机场45-60分钟。该位置可快速到达基本服务和主要交通路线,适合需要高效移动性和技术先进、运营成本低的物业的买家。',

  // Amenities
  amenities_title: '高端设施',
  amenities_subtitle: '卓越生活方式的高端功能',
  amenities_smart_home: '智能家居系统',
  amenities_smart_home_desc: '照明、气候和安全的完整智能自动化',
  amenities_heating: '地暖',
  amenities_heating_desc: '整个物业的分区辐射供暖',
  amenities_climate: 'Daikin 气候控制',
  amenities_climate_desc: '优质 HVAC 系统，提供最佳舒适度',
  amenities_pool: '加热盐水泳池',
  amenities_pool_desc: 'LED 色彩疗法，自动平衡盐和 pH 值',
  amenities_audio: 'Bang & Olufsen 系统',
  amenities_audio_desc: '整个家庭的集成音视频系统',
  amenities_security: '安全系统',
  amenities_security_desc: '先进的警报和闭路电视监控',
  amenities_wellness: '桑拿和健康',
  amenities_wellness_desc: '私人水疗区配有桑拿（正在建设中）',
  amenities_fitness: '健身空间',
  amenities_fitness_desc: '配备专业设备的专用健身房区域',
  amenities_wine: '酒窖',
  amenities_wine_desc: '为您的收藏提供气候控制存储',
  amenities_irrigation: '智能灌溉',
  amenities_irrigation_desc: '带雨水收集系统的自动花园浇水',
  amenities_ev: '电动汽车充电站',
  amenities_ev_desc: '车库内的电动汽车充电',
  amenities_solar: '太阳能系统',
  amenities_solar_desc: '20 kW 光伏系统，配备 40 kWh 电池存储',

  // Gallery
  gallery_title: '照片画廊',
  gallery_img_1: '外观 – 游泳池区域',
  gallery_img_2: '带车库的前外观',
  gallery_img_3: '花园和泳池休息区',
  gallery_img_4: '带露台和太阳能屋顶的后外观',
  gallery_img_5: '室外有盖露台',
  gallery_img_6: '外观侧角',
  gallery_img_7: '鸟瞰图(外观)',
  gallery_img_8: '客厅(一楼)',
  gallery_img_9: '带壁炉的客厅(一楼)',
  gallery_img_10: '客厅(一楼)',
  gallery_img_11: '客厅(一楼)',
  gallery_img_12: '可观露台的客厅(一楼)',
  gallery_img_13: '客厅(一楼)',
  gallery_img_14: '客厅 B&O Beosound Shape(一楼)',
  gallery_img_15: '主入口大厅(一楼)',
  gallery_img_16: '主入口大厅(一楼)',
  gallery_img_17: '带玻璃栏杆的开放式楼梯(一楼)',
  gallery_img_18: '带玻璃栏杆的开放式楼梯(一楼)',
  gallery_img_19: '浴室(一楼)',
  gallery_img_20: '用餐区(一楼)',
  gallery_img_21: '餐厅(一楼)',
  gallery_img_22: '餐桌(一楼)',
  gallery_img_23: '厨房(一楼)',
  gallery_img_24: '卧室(一楼)',
  gallery_img_25: '步入式衣柜(一楼)',
  gallery_img_26: '健身房(一楼)',
  gallery_img_27: '浴室(一楼)',
  gallery_img_28: '浴室(一楼)',
  gallery_img_29: '浴室(一楼)',
  gallery_img_30: '阁楼(二楼)',
  gallery_img_31: '卧室(二楼)',
  gallery_img_32: '卧室(二楼)',
  gallery_img_33: '浴室(二楼)',
  gallery_img_34: '卧室(二楼)',
  gallery_img_35: '浴室(二楼)',
  gallery_img_36: '浴室(二楼)',
  gallery_img_37: '楼梯(底层)',
  gallery_img_38: '厨房和家庭影院(底层)',
  gallery_img_39: '用餐区(底层)',
  gallery_img_40: '带壁炉的客厅(底层)',
  gallery_img_41: '客厅(底层)',
  gallery_img_42: '浴室（底层）',
  gallery_img_43: '车库（底层）',
  gallery_img_44: '22千瓦电动汽车充电器提供快速充电，约4-5小时即可完全充满100千瓦时电池。',
  gallery_img_45: '车库（底层）',
  gallery_img_46: '花园景观(底层)',
  gallery_img_47: '底层平面图',
  gallery_img_48: '一楼平面图',
  gallery_img_49: '二楼平面图',
  gallery_img_50: '底层平面图',
  gallery_img_51: '一楼平面图',
  gallery_img_52: '二楼平面图',

  // Materials & Finishes
  materials_title: '材料与装饰',
  materials_stone: '法国石材',
  materials_stone_desc: '厨房和浴室采用优质天然石材',
  materials_teak: '船用级柚木',
  materials_teak_desc: '耐用的户外地板和家具',
  materials_carpentry: '定制木工',
  materials_carpentry_desc: '意大利手工木制品',
  materials_audio: 'Bang & Olufsen',
  materials_audio_desc: '集成音视频娱乐系统',
  materials_climate: 'Daikin 气候控制',
  materials_climate_desc: '多区域供暖和制冷系统',
  materials_appliances: '高端电器',
  materials_appliances_desc: '厨房和洗衣房采用欧洲顶级品牌',
  
  // Material Details
  material_1_name: '船用级柚木',
  material_1_desc: '卧室和夹层地板',
  material_2_name: '罗马洞石',
  material_2_desc: '主套房浴室',
  material_3_name: '伦巴第采石场天然石材',
  material_3_desc: '底层铺装',
  material_4_name: '大理石粉与树脂',
  material_4_desc: '泳池边地板。复合材料设计用于减少阳光照射下室外地板的过热，并确保防滑表面。',
  material_5_name: '黑色花岗岩',
  material_5_desc: '厨房台面',
  material_6_name: '法国石材',
  material_6_desc: '一楼地板',
  material_7_name: '落叶松木',
  material_7_desc: '厨房橱柜',

  // Key Info Details
  keyinfo_location_title: '位置',
  keyinfo_location_1: 'Via Binaghetto 3, Arcisate (VA), 意大利',
  keyinfo_location_2: '距瓦雷泽 8 公里',
  keyinfo_location_3: '距瑞士卢加诺 30 分钟',
  keyinfo_location_4: '距马焦雷湖 30 公里',
  keyinfo_location_5: '距米兰 50-60 分钟',
  keyinfo_location_6: '距马尔彭萨机场 37 公里',
  
  keyinfo_property_title: '物业详情',
  keyinfo_property_1: '年份：2007–2010',
  keyinfo_property_2: '总室内面积：505平方米',
  keyinfo_property_3: '花园：约1,190平方米',
  keyinfo_property_4: '能源等级：A3',
  keyinfo_property_5: '3层',
  keyinfo_property_6: '高端建筑设计',
  
  keyinfo_layout_title: '布局与房间',
  keyinfo_layout_1: '4间卧室',
  keyinfo_layout_2: '5间浴室',
  keyinfo_layout_3: '宽敞的起居区',
  keyinfo_layout_4: '主厨房',
  keyinfo_layout_5: '第二厨房',
  keyinfo_layout_6: '家庭办公',
  keyinfo_layout_7: '健身/健身房区域',
  keyinfo_layout_8: '酒窖',
  keyinfo_layout_9: '洗衣房',
  keyinfo_layout_10: '大型多功能房',
  
  keyinfo_pool_title: '泳池和户外',
  keyinfo_pool_1: '盐水泳池（加热）',
  keyinfo_pool_2: 'LED色彩疗法系统',
  keyinfo_pool_3: '户外休息区',
  keyinfo_pool_4: '景观花园',
  keyinfo_pool_5: '自动灌溉系统',
  keyinfo_pool_6: '10,000升地下雨水收集罐',
  
  keyinfo_parking_title: '停车',
  keyinfo_parking_1: '室内车库：最多4辆车',
  keyinfo_parking_2: '户外停车场：3个额外车位',
  keyinfo_parking_3: '电动汽车充电站',
  keyinfo_parking_4: '有组织的储物区',
  
  keyinfo_energy_title: '能源系统',
  keyinfo_energy_1: '光伏：2个系统，总计20千瓦',
  keyinfo_energy_2: '电池储存：40千瓦容量',
  keyinfo_energy_3: '太阳能热能：10块面板',
  keyinfo_energy_4: '高效热泵',
  keyinfo_energy_5: '燃气备用系统',
  keyinfo_energy_6: '分区地暖',
  keyinfo_energy_7: '大金气候控制',
  
  keyinfo_materials_title: '高端材料',
  keyinfo_materials_1: '法国石材（厨房和浴室）',
  keyinfo_materials_2: '船用级柚木（门廊）',
  keyinfo_materials_3: '伦巴第采石场天然石材',
  keyinfo_materials_4: '大理石粉与树脂（泳池边）',
  keyinfo_materials_5: '黑色花岗岩（厨房台面）',
  keyinfo_materials_6: '落叶松木（厨房橱柜）',
  keyinfo_materials_7: '罗马洞石（主套房浴室）',
  
  keyinfo_tech_title: '技术与安全',
  keyinfo_tech_1: '完整智能家居系统（家庭自动化）',
  keyinfo_tech_2: 'Bang & Olufsen音视频系统',
  keyinfo_tech_3: '先进报警系统',
  keyinfo_tech_4: '闭路电视监控',
  keyinfo_tech_5: '自动照明控制',
  keyinfo_tech_6: '气候区管理',
  keyinfo_tech_7: '通过Buderus应用程序进行光伏性能监控和热泵及锅炉控制和管理',
  
  keyinfo_main_title: '房产信息',
  keyinfo_main_subtitle: '完整规格和特点',

  // Security & Safety
  security_title: '安全与保障',
  security_intro: '该物业包括一整套现代安全系统，旨在确保可靠的保护和便捷的远程管理。',
  security_features_heading: '主要安全功能：',
  security_alarm: '带远程控制的报警系统',
  security_alarm_desc: '现代化的报警系统，可通过智能手机远程控制，让您随时随地监控和管理安全。',
  security_cameras: '视频监控摄像头',
  security_cameras_desc: '在物业周围的关键位置安装高清摄像头，提供持续的监控和录像。',
  security_windows: '防破窗户',
  security_windows_desc: '所有窗户均配备加固防碎玻璃，以提高保护性。',
  security_doors: '加固入口门',
  security_doors_desc: '主入口门内部采用金属结构建造，以提高抗性和整体安全性。',
  security_lighting: '安全照明',
  security_lighting_desc: '运动激活的外部照明',
  security_fire: '消防安全',
  security_fire_desc: '烟雾探测器和灭火系统',
  security_monitoring: '24/7监控',
  security_monitoring_desc: '可选的专业安保服务集成',

  // Automation & Smart Controls
  automation_title: '自动化与智能控制',
  automation_intro: '别墅配备了多个自动化系统,旨在简化日常使用并提高整个房屋的效率。',
  automation_exterior_title: '外部百叶窗:',
  automation_exterior_1: '通过中央控制单元操作。',
  automation_exterior_2: '采用防水和防雪材料制造,经久耐用。',
  automation_exterior_3: '在强风中自动收回以提供额外保护。',
  automation_exterior_4: '设计时无需上部"盒式箱",确保建筑外观整洁。',
  automation_exterior_5: '包含视频演示。',
  automation_interior_title: '内部百叶窗:',
  automation_interior_1: '通过房屋内的中央触摸屏控制。',
  automation_interior_2: '只需点击几下即可升降单个房间、整层楼或整栋房子。',
  automation_interior_3: '平稳、安静的操作,专为频繁使用而设计。',
  automation_interior_4: '包含视频演示。',
  automation_video_external: '上传视频:外部百叶窗自动化演示。',
  automation_video_internal: '上传视频:内部百叶窗控制演示。',

  // Operating Costs
  costs_title: '运营成本与能源效率',
  costs_intro: '这座别墅的设计旨在控制运营成本，同时全年保持高水平的舒适度。得益于先进的能源系统和现场生产，相对于房产的规模和性能，总体费用保持在较低水平。',
  costs_annual_title: '年度运营成本（约）：',
  costs_water: '水费',
  costs_water_amount: '€635.20',
  costs_internet: '互联网和电话',
  costs_internet_amount: '€424.68',
  costs_electricity_consumed: '电力消耗',
  costs_electricity_consumed_amount: '€2,038.17',
  costs_gas: '燃气',
  costs_gas_amount: '€2,855.00',
  costs_total_utilities: '公用事业总计',
  costs_total_utilities_amount: '€5,952.00',
  costs_electricity_sold: '售回电网的电力',
  costs_electricity_sold_amount: '– €2,750.00',
  costs_waste_tax: '市政垃圾税',
  costs_waste_tax_amount: '€485.75',
  costs_net_annual: '估计年度净成本',
  costs_net_annual_amount: '€3,687.00',
  costs_comfort_title: '舒适和气候控制：',
  costs_comfort_pool: '从5月到9月，室外游泳池（约88,000升）加热至28°C。',
  costs_comfort_home: '整个房屋全年保持恒定的22°C，无论夏季还是冬季，通过大金热泵用于夏季期间和Buderus热泵用于地暖管理。',
  costs_image_caption: '上传图片：能源仪表板、游泳池或技术信息图。',

  // Operating Costs Details
  costs_details_intro: '基于平均使用量的估计年度运营成本。实际成本可能有所不同。',
  costs_energy_desc: '电力和燃气消耗',
  costs_water_desc: '供水和污水',
  costs_maintenance_desc: '定期维护和保养',
  costs_estimate_title: '估计年度能源消耗',
  costs_estimate_heating: '供暖',
  costs_estimate_heating_value: '12,000千瓦时/年',
  costs_estimate_cooling: '制冷',
  costs_estimate_cooling_value: '3,500千瓦时/年',
  costs_estimate_hot_water: '热水',
  costs_estimate_hot_water_value: '4,200千瓦时/年',
  costs_estimate_appliances: '电器和照明',
  costs_estimate_appliances_value: '5,800千瓦时/年',
  costs_estimate_total: '总计估计',
  costs_estimate_total_value: '25,500千瓦时/年',
  costs_estimate_note: '太阳能电池板和电池储能显著抵消这些成本',

  // Stats
  stats_energy: '能源自给自足',
  stats_water: '收集的雨水',
  stats_solar: '产生的太阳能',
  stats_efficiency: '能源效率',

  // By the Numbers Section
  by_numbers_title: '数据一览',
  by_numbers_subtitle: '定义卓越的令人印象深刻的规格',
  by_numbers_solar_generated: '太阳能发电量',
  by_numbers_solar_value: '8.21兆瓦时/年',
  by_numbers_rainwater: '雨水收集量',
  by_numbers_rainwater_value: '10,000升',
  by_numbers_living_space: '居住空间',
  by_numbers_living_value: '505平方米',
  by_numbers_garden: '花园面积',
  by_numbers_garden_value: '1,190平方米',
  by_numbers_bedrooms: '卧室',
  by_numbers_bedrooms_value: '4',
  by_numbers_bathrooms: '浴室',
  by_numbers_bathrooms_value: '5',
  by_numbers_garage: '车库车位',
  by_numbers_garage_value: '4',
  by_numbers_solar_capacity: '光伏装置功率',
  by_numbers_solar_capacity_value: '20千瓦',
  by_numbers_battery_capacity: '储能容量',
  by_numbers_battery_capacity_value: '40千瓦时',
  by_numbers_year: '年',

  // Premium Services Section
  premium_services_title: '高端服务',
  premium_services_subtitle: '卓越生活方式的高端功能',
  premium_service_1_title: '智能家居系统',
  premium_service_1_desc: '照明、气候和安全的完整家庭自动化',
  premium_service_2_title: '地暖系统',
  premium_service_2_desc: '整个物业的分区辐射供暖',
  premium_service_3_title: '大金空调控制',
  premium_service_3_desc: '高端暖通空调系统，提供最佳舒适度',
  premium_service_4_title: '加热盐水泳池',
  premium_service_4_desc: 'LED色彩疗法，自动平衡盐度和pH值',
  premium_service_5_title: '太阳能系统',
  premium_service_5_desc: '20千瓦光伏系统，配备40千瓦时电池储能',
  premium_service_6_title: '雨水收集',
  premium_service_6_desc: '10,000升收集系统用于灌溉',
  premium_service_7_title: 'Bang & Olufsen音响',
  premium_service_7_desc: '整个住宅的高端集成音响系统',
  premium_service_8_title: '安全系统',
  premium_service_8_desc: '先进的警报和闭路电视监控',
  premium_service_9_title: '电动汽车充电站',
  premium_service_9_desc: '车库内的电动汽车充电',

  // Location
  location_title: '优越地理位置',
  location_subtitle: 'Arcisate - 自然与便利的完美平衡',
  location_description: "这座别墅位于阿尔奇萨泰风景如画的乡村，在宁静与便利之间提供完美平衡。享受大自然的宁静，同时距离主要城市、国际机场和迷人的湖泊仅几分钟路程。",
  
  // Location Carousel Captions
  location_carousel_caption_1: "瓦雷泽 – 坎波代菲奥里（联合国教科文组织遗产地）",
  location_carousel_caption_2: "瓦雷泽 – 公共花园",
  location_carousel_caption_3: "瓦雷泽 – 历史中心",
  location_carousel_caption_4: "瓦雷泽湖",
  location_carousel_caption_5: "瓦雷泽湖",
  location_carousel_caption_6: "米兰 – 大教堂广场",
  location_carousel_caption_7: "米兰 – 维托里奥·埃马努埃莱二世拱廊",
  location_carousel_caption_8: "米兰 – 城市景观",
  location_carousel_caption_9: "科莫湖",
  location_carousel_caption_10: "科莫湖 – 贝拉焦",
  location_train: '火车站',
  location_train_desc: '步行5分钟 - 直达瓦雷泽、米兰、科莫、瑞士',
  location_varese: '瓦雷泽',
  location_varese_desc: '开车15分钟 - 市中心和服务设施',
  location_lugano: '卢加诺(瑞士)',
  location_lugano_desc: '开车30分钟 - 瑞士边境和湖泊',
  location_milan: '米兰/马尔彭萨',
  location_milan_desc: '开车45-60分钟 - 国际机场和城市',

  // Contact
  contact_title: '安排看房',
  contact_subtitle: '对这处卓越的房产感兴趣？联系我们安排私人参观。',
  contact_name: '全名',
  contact_email: '电子邮件地址',
  contact_phone: '电话号码',
  contact_message: '留言',
  contact_message_placeholder: '告诉我们您对这处房产的兴趣...',
  contact_submit: '发送消息',
  contact_success: '谢谢！我们会尽快与您联系。',
  contact_error: '请填写所有必填字段。',

  // Visit & Viewing Arrangements
  viewing_title: '参观与看房安排',
  viewing_intro: '我们希望您的参观尽可能顺利和舒适。',
  viewing_translator: '如果您不会说意大利语，无需担心——我们将安排专业翻译在参观期间在场，以确保始终进行清晰准确的沟通。',
  viewing_flexible: '我们在时间安排方面也非常灵活。日期和时间可以根据您的可用性安排，特别考虑从国外旅行的客人。',
  viewing_contact: '请随时联系我们提出您的首选时间，我们将尽最大努力安排您的参观。',

  // Footer
  footer_about: '关于此房产',
  footer_about_text: 'Arcisate的现代别墅,结合智能技术、能源效率和优质材料,实现现代可持续生活。',
  footer_quick_links: '快速链接',
  footer_contact_info: '联系信息',
  footer_email: '电子邮箱',
  footer_phone: '电话',
  footer_address: '地址',
  footer_address_value: '意大利瓦雷泽省Arcisate',
  footer_rights: '版权所有。',
  footer_privacy: '隐私政策',
  footer_terms: '服务条款',

  // Form Validation
  validation_required: '此字段为必填项',
  validation_email: '请输入有效的电子邮箱地址',
  validation_phone: '请输入有效的电话号码',
  validation_max_length: '最多允许500个字符',
};

export default translation;